import type { IDictionaryCompanyRole } from '@/creditflowresearch/domain/vo/IDictionary';
import type { ICheckboxOption } from '@/creditflowresearch/ui/common/hooks/sidebar/useCheckboxFilter';

const LEAD_ROLE_ORDER: { type: string, displayName: string }[] = [
  { type: 'activeLead', displayName: 'Active Leads' },
  { type: 'jointLead', displayName: 'Joint Leads' },
  { type: 'leftLead', displayName: 'Lead Left' },
  { type: 'passiveLead', displayName: 'Passive Leads' },
  { type: 'coManager', displayName: 'Co-Managers' },
  { type: 'coordinatingManager', displayName: 'Coordinating Manager' },
  { type: 'billingDelivering', displayName: 'B&D' },
];

export const buildLeadRoleOptions = (roles: IDictionaryCompanyRole[]): ICheckboxOption<number>[] => {
  const roleByType = new Map(roles.map((r) => [r.type, r]));

  return LEAD_ROLE_ORDER.reduce<ICheckboxOption<number>[]>((acc, { type, displayName }) => {
    const role = roleByType.get(type);
    if (role) {
      acc.push({ value: role.id, name: displayName });
    }
    return acc;
  }, []);
};
